import dayjs from "dayjs";
import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DateRange } from "@/domains/common";
import {
  TransferRead,
  TransferService,
  TransferQueryParams,
  TransferCategory,
} from "@/domains/transfer";
import { RootState } from "@/stores";

interface OperatorSelfWithdrawState {
  loading: boolean;
  dateRange: DateRange;
  queryParams: TransferQueryParams;
  transfers: TransferRead[];
}

const initialState: OperatorSelfWithdrawState = {
  loading: false,
  dateRange: DateRange.day0,
  queryParams: {
    created_started_at: dayjs().startOf("day").toISOString(),
    created_stopped_at: dayjs().endOf("day").toISOString(),
  },
  transfers: [],
};

export const operatorSelfWithdrawSelects = {
  loading: (state: RootState) => state.operatorSelfWithdraw.loading,
  dateRange: (state: RootState) => state.operatorSelfWithdraw.dateRange,
  queryParams: (state: RootState) => state.operatorSelfWithdraw.queryParams,
  transfers: (state: RootState) => state.operatorSelfWithdraw.transfers,
};

export const operatorSelfWithdrawThunks = {
  list: createAsyncThunk(
    "operatorSelfWithdraw/list",
    async (params: TransferQueryParams = {}) => {
      const res = await TransferService.list({
        ...params,
        category: TransferCategory.OperatorWithdraw,
      }).run();

      return res.data.msg;
    }
  ),
};

export const operatorSelfWithdrawSlice = createSlice({
  name: "operatorSelfWithdraw",
  initialState,
  reducers: {
    setQueryParams: (state, action: PayloadAction<TransferQueryParams>) => {
      state.queryParams = action.payload;
    },
    setDateRange: (state, action: PayloadAction<DateRange>) => {
      state.dateRange = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(operatorSelfWithdrawThunks.list.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      operatorSelfWithdrawThunks.list.fulfilled,
      (state, action) => {
        state.loading = false;
        state.transfers = action.payload.transfers;
      }
    );
    builder.addCase(operatorSelfWithdrawThunks.list.rejected, (state) => {
      state.loading = false;
      state.transfers = [];
    });
  },
});

export const operatorSelfWithdrawActions = operatorSelfWithdrawSlice.actions;
